<template>
    <div class="modal_cont delivery_modal">
        <div class="modal_header">
            <a href="#none" @click="closeModal" class="btn_close">닫기</a>
        </div>

        <div class="modal_content">
            <section>
                <p>제보가 정상적으로 접수되었습니다.</p>
            </section>
        </div>

        <div class="modal_bottom">
            <div class="btnBox">
                <a href="#none" @click="closeModal" class="btn_mid primary">확인</a>
            </div>
        </div>
    </div>
</template>

<script>
import modal from "@/utils/popupModal";

export default {
    name: "gsrsu04010101",
    props: {
        onClose: { type: Function, default: null }
    },
    methods: {
        closeModal() {
            modal.closeAll();
            if (this.onClose) this.onClose();
        }
    }
};
</script>

<style scoped>
.modal_header { display: flex; align-items: center; justify-content: flex-end; padding-bottom: 40px; border-bottom: 0 !important; }
.modal_content p { margin-bottom: 12px; font-size: 18px; font-weight: 700; text-align: center; word-break: keep-all; }
section { display: flex; flex-direction: column; align-items: center; }
</style>
